import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BoltIcon } from "../components/Decorations";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6 py-20"
    >
      <Seo title="404 — Halaman tidak ditemukan | ListrikBatam.com" description="Halaman yang Anda cari tidak tersedia." />
      <BoltIcon className="w-20 h-28 bolt-flicker mb-6" color="#FF6B00" />
      <div className="font-display text-7xl md:text-9xl font-black text-[#0F4C75]">404</div>
      <h1 className="mt-4 font-display text-2xl md:text-3xl font-bold text-[#1B262C]">
        Halaman tidak ditemukan
      </h1>
      <p className="mt-3 max-w-md text-[#1B262C]/70">
        Mungkin alamatnya salah ketik. Silakan kembali ke beranda atau telusuri
        layanan kami.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-2 bg-[#FF6B00] text-white font-bold rounded-full px-6 py-3"
        data-testid="back-home-btn"
      >
        <ArrowLeft className="w-4 h-4" /> Kembali ke Beranda
      </Link>
    </div>
  );
}
